import { Controller } from '@hotwired/stimulus';

// Generic controller to dismiss an element via localStorage.
// Usage:
//   <div data-controller="local-storage-dismiss"
//        data-local-storage-dismiss-key-value="my_dismiss_key">
//     <div data-local-storage-dismiss-target="dismissable">
//       Content to dismiss
//       <button data-action="local-storage-dismiss#dismiss">Dismiss</button>
//     </div>
//   </div>
export default class extends Controller {
  static values = { key: String };
  static targets = ['dismissable'];

  connect() {
    if (this.isDismissed()) {
      this.hide();
    }
  }

  dismiss() {
    try {
      localStorage.setItem(this.keyValue, 'true');
    } catch {
      // localStorage unavailable (private browsing, quota exceeded) — hide anyway
    }
    this.hide();
  }

  // private

  isDismissed() {
    try {
      return localStorage.getItem(this.keyValue) === 'true';
    } catch {
      return false;
    }
  }

  hide() {
    if (this.hasDismissableTarget) {
      this.dismissableTarget.style.transition = 'opacity 200ms ease-out';
      this.dismissableTarget.style.opacity = '0';
      setTimeout(() => this.dismissableTarget.remove(), 200);
    }
  }
}
